import React, { useEffect } from 'react';

const SmilingVideoPlayer = () => {
  useEffect(() => {
    // --- 1. Load the Google IMA SDK script ---
    const imaSdkScriptId = 'ima-sdk-script';
    if (!document.getElementById(imaSdkScriptId)) {
      const imaScript = document.createElement('script');
      imaScript.id = imaSdkScriptId;
      imaScript.src = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';
      imaScript.async = true;
      // imaScript.onload = () => {
      //   console.log('IMA SDK loaded.');
      //   // If smVideomaticStart directly depends on IMA SDK, call it here.
      //   // Based on original snippet, it's called independently.
      // };
      document.head.appendChild(imaScript);
    }

    // --- 2. Define global variables required by the Smiling Video script ---
    // It's often best to place these on the window object for external scripts
    window.smIdUser = 1411;

    // Ensure smVideos and smOptions are initialized if they don't exist
    window.smVideos = window.smVideos || [];
    const videoEntry = { video: 613432 };
    // Prevent duplicate video entries if the effect runs multiple times (e.g., in StrictMode)
    if (!window.smVideos.find((v) => v.video === videoEntry.video)) {
      window.smVideos.push(videoEntry);
    }

    window.smOptions = window.smOptions || {};
    window.smOptions['ap'] = 0;
    window.smOptions['mtd'] = 0;
    window.smOptions['smsz'] = 'videomaticNormal';
    window.smEnableVideoMatic = false;

    // --- 3. Define and execute the smVideomaticStart function logic ---
    const smVideomaticStart = () => {
      const runScriptDiv = document.getElementById('sm_videomatic');
      if (!runScriptDiv) {
        console.error('Error: sm_videomatic div not found in the DOM.');
        return;
      }

      // Prevent re-injecting the smLoader script if it's already there
      if (
        runScriptDiv.querySelector('script[src*="smLoader-0.1.1.js"]') ||
        runScriptDiv.querySelector('script#sm-dynamic-loader')
      ) {
        // console.log('Smiling Video loader script seems to be already initiated or present.');
        return;
      }

      const asyncJs = 'https://vid1aws.smiling.video/SmilingVideoResponder/asynclibs/smLoader-0.1.1.js';
      const xhr = new XMLHttpRequest();
      xhr.onload = function (e) {
        if (xhr.status === 200) {
          const newScript = document.createElement('script');
          newScript.id = 'sm-dynamic-loader'; // Add an ID for easier identification
          const xhrTarget = e?.target as XMLHttpRequest | null;
          if (xhrTarget?.responseText) {
            newScript.innerHTML = xhrTarget.responseText;
            runScriptDiv.appendChild(newScript);
          }
        } else {
          console.error(`Failed to load smLoader script. Status: ${xhr.status}`);
        }
      };
      xhr.onerror = function () {
        console.error('Error during XHR request for smLoader script.');
      };
      xhr.open('GET', asyncJs, true);
      xhr.send();
    };

    // Call smVideomaticStart
    // Use a flag to prevent multiple executions in React 18 Strict Mode (dev only)
    // or if the component were to re-render and re-run the effect without cleanup.
    if (!window.smVideomaticInitialized) {
      smVideomaticStart();
      window.smVideomaticInitialized = true;
    }

    // --- 4. Cleanup (optional but good practice) ---
    return () => {
      // If the video player or scripts add global event listeners or timers,
      // they should be cleaned up here. This might be complex depending on the
      // external script's behavior.
      // For this specific case, the primary action is loading other scripts.
      // Resetting the initialized flag might be useful if the component can be
      // unmounted and remounted, and you need the script to re-initialize.
      // window.smVideomaticInitialized = false;
      // You might also consider removing dynamically added scripts or a more thorough cleanup
      // of global variables if they are strictly tied to this component's lifecycle and
      // shouldn't persist. However, be cautious as other parts of the application or
      // the script itself might rely on them.
    };
  }, []); // Empty dependency array means this effect runs once after initial render and cleans up on unmount.

  return (
    <div className='my-5 aspect-video w-full max-w-96 overflow-hidden'>
      {/* These divs are part of your original snippet */}
      <div id='sm_videomatic'></div>
      <div id='sm_playerDiv_613432'></div>

      {/* This script tag is empty in your snippet. It's likely a placeholder
          that the dynamically loaded scripts will use. React will render it
          as an empty script tag in the DOM. */}
      <script id='smScript_613432'></script>
    </div>
  );
};

export default SmilingVideoPlayer;
